import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { IntlProviderWrapper } from './context/Internationalization'

const app = (
  <IntlProviderWrapper>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </IntlProviderWrapper>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
